import React from "react";
import Tooltip from "@/components/Tooltip";

interface MissingField {
  label: string;
  path: string;
}

interface FormValidationTooltipProps {
  children: React.ReactElement;
  missingFields: MissingField[];
  showTooltip: boolean;
  title?: string;
}

const MissingFieldLabel = ({ field }: { field: MissingField }) => {
  return <span className="text-sm">{field.label}</span>;
};

const MissingFieldsList = ({ fields }: { fields: MissingField[] }) => {
  if (fields.length === 0) return null;

  return (
    <ul className="list-disc pl-4 space-y-1">
      {fields.map((field, index) => (
        <li key={index}>
          <MissingFieldLabel field={field} />
        </li>
      ))}
    </ul>
  );
};

export function FormValidationTooltip({
  children,
  missingFields,
  showTooltip,
  title = "Required Fields"
}: FormValidationTooltipProps) {
  if (!React.isValidElement(children)) {
    console.warn("FormValidationTooltip: children is not a valid React element.");
    return null;
  }

  if (!showTooltip || missingFields.length === 0) {
    return children;
  }

  return (
    <Tooltip
      title={title}
      supportingText={<MissingFieldsList fields={missingFields} />}
      variant="rich"
      color="white"
      compactHoverArea={true}
    >
      {children}
    </Tooltip>
  );
}
